export const STATUS = {
  PENDING: 'PENDING',
  CONNECTED: 'CONNECTED',
  DENIED: 'DENIED',
  REVOKED: 'REVOKED',
};
